module.exports = __webpack_public_path__ + "static/media/scamp1.20599719.png";